/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ApiUserSearchSortKind {
  Id = 'id',
  Name = 'name',
  EmailAddress = 'emailAddress',
  LatestLogin = 'latestLogin',
  Source = 'source'
}
